import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { v4 } from 'uuid';
import { KinesisVideoStreamContext } from '../../Context/KinesisVideoStreamContext';
import { useContext, useReducer } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { NodeEdgeMapper, VideoHubClassName, VideoStreamClassName, VideoHub as VideoHubClass, VideoStream as VideoStreamClass, } from '@iotv/datamodel-core';
import { DeviceControlDAO } from '../../../../data/DeviceControlDAO/DeviceControlDAO';
import { Button, Stack } from '@mui/material';
import { getPulseSX } from '../../../../cosmetics/sx';
import { Severity } from '../../../../types';
const defaultState = {
    requesting: false,
};
const VideoControlsReducer = (prev, next) => ({ ...prev, ...next });
export const VideoControls = (props) => {
    const [localState, localDispatch] = useReducer(VideoControlsReducer, defaultState);
    const { state, dispatch } = useContext(KinesisVideoStreamContext);
    const [{ UserFunctions }, appMainDispatch] = useContext(AppMainViewContext);
    const { VideoStream, VideoHub } = state;
    const sendVideoControl = async () => {
        if (!VideoStream || !VideoHub) {
            console.error('Error: VideoStream or VideoHub is undefined');
            return;
        }
        localDispatch({ requesting: true });
        const nodeEdgeMapper = new NodeEdgeMapper();
        nodeEdgeMapper.loadItems([VideoStream, VideoHub]);
        const { err, data } = await DeviceControlDAO.video.resolve.items({ nodeEdgeMapper });
        if (err) {
            console.error('Error sending video control:', err);
            UserFunctions.setUserMessage({ content: `Error sending video control: ${err.message}`, severity: Severity.error, id: v4(), label: 'Video Control Error', type: 'MessageBar' });
        }
        else if (data) {
            console.log('Video control sent successfully:', data);
            const nodeEdgeMapper = data;
            const videoHub = nodeEdgeMapper.getNodesOfType(VideoHubClassName)[0];
            const videoStreams = nodeEdgeMapper.getNodesOfType(VideoStreamClassName);
            const videoStream = videoStreams.length > 0 ? videoStreams[0] : null;
            if (videoStream && videoHub) {
                dispatch({
                    VideoHub: new VideoHubClass(videoHub),
                    VideoStream: new VideoStreamClass(videoStream),
                });
                UserFunctions.addObjectsToState([videoHub, videoStream]);
            }
            localDispatch({ requesting: false });
        }
    };
    return (_jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: _jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: _jsxs(Button, { sx: localState.requesting ? getPulseSX({ animationDuration: 1 }) : {}, variant: "contained", color: VideoStream?.SiteWiseAssetIdForCamera ? 'inherit' : 'primary', disabled: localState.requesting, onClick: () => {
                    sendVideoControl();
                }, children: [VideoStream?.SiteWiseAssetIdForCamera ? 'Revalidate' : 'Validate', " Video Stream"] }) }) }));
};
